<p-dialog header="Upload Files" [(visible)]="visible" [style]="{width: '50vw'}" [modal]="true" [draggable]="false" [resizable]="false" [breakpoints]="{ '960px': '75vw' }" [dismissableMask]="false" (onHide)="onDialogHide()">
    <div class="oi-main-dshd uploadfile">
      <div class="imgloader" *ngIf="uploadLoader">
        <img src="../../assets/img/loader.gif">
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="oi-upload-dc-main">
            <div class="row">
              <div class="col-md-6">
                <div class="oi-upload-lft">
                  <div class="oi-file-upload-btn">
                    <button class="btn btn-default">Upload a file</button>
                    <input type="file" name="myfile" accept=".pdf,.doc,.xlsx,.txt" multiple (change)="onFileSelected($event)" />
                  </div>
                  <div class="oi-file-text">
                    Max file size: <strong>50MB</strong><br>
                    Supported file types: .pdf,.doc,.xlsx,.txt
                  </div>
                </div>
                <div class="oi-file-nm-submt">
                  <button class="btn btn-default" (click)="uploadFilestoserver()">Submit</button>
                </div>
              </div>
              <div class="col-md-6">
                <div class="oi-file-name">
                  <ul>
                    <li *ngFor="let file of files" class="d-flex justify-content-start">
                      <span>{{getfiletype(file.name)}}</span> 
                      <span class="oi-fl-path">{{file.name}}</span>
                      <span class="oi-upld-close"><img src="../../assets/img/close.svg" (click)="onDelete(file)" class="hover"></span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </p-dialog>
  